import PropTypes from 'prop-types';
import { Anchor, Button, Heading, ModalDialog, Paragraph } from '@zillow/constellation';
import { useSelector } from 'react-redux';
import { propertyAddressSelector } from '../../../../selectors';
import useQueryVariables from '../../../../hooks/useQueryVariables';
import { useListingUser } from '../../../../hooks/useListingUser';
import { emitEnrollmentToggleDisableConfirmEvent } from '../../../../../client/analytics/clickstreamEvents';

export default function UnenrollModal({ unenrollModalOn, closeUnenrollModal, setEnrollmentStatus }) {
  const displayAddress = useSelector(propertyAddressSelector);
  const { propertyId } = useQueryVariables();
  const editPageUrl = `/rental-manager/properties/${propertyId}/listing`;
  const { user, listing } = useListingUser();

  function turnOffApplicationsEnrollment() {
    emitEnrollmentToggleDisableConfirmEvent(listing, user);

    setEnrollmentStatus({
      applicationsAccepted: false,
      propertyId,
    });
  }

  return (
    <ModalDialog
      wide
      id="enrollment-modal"
      isOpen={unenrollModalOn}
      onClose={closeUnenrollModal}
      header={
        <Heading level={6} as="h2">
          Show "Apply Now" Button
        </Heading>
      }
      body={
        <>
          <Paragraph marginBottom="sm">Are you sure you would like to stop showing the "Apply now" button?</Paragraph>
          <Paragraph marginBottom="sm">
            Potential tenants will no longer be able to submit online applications for your property at {displayAddress}
            .
          </Paragraph>
          <Paragraph marginBottom="sm">
            You'll still be able to invite people to apply and receive applications from renters who have started to
            apply.
          </Paragraph>
          <Paragraph marginBottom="sm">
            Found your tenant? <Anchor href={editPageUrl}>Remove your listing.</Anchor>
          </Paragraph>
          <Button buttonType="primary" id="enrollment-button" fluid onClick={turnOffApplicationsEnrollment}>
            Turn off applications
          </Button>
        </>
      }
    />
  );
}

UnenrollModal.propTypes = {
  unenrollModalOn: PropTypes.bool.isRequired,
  closeUnenrollModal: PropTypes.func.isRequired,
  setEnrollmentStatus: PropTypes.func.isRequired,
};
